
const version = '1.1.2'

async function checkAppVersion() {
  try {
    const savedVersion = localStorage.getItem("app_version");

    if (savedVersion !== version) {
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("app_version", version);

      console.log("Storage cleared & new version saved:", version);
    } else {
      console.log("Version same hai:", version);
    }
  } catch (error) {
    console.error("Version check failed:", error);
  }
}

export default checkAppVersion